import { IExternalDetailsResponse, TToponymKind } from './geoSuggest.types'

type TAddressFields = { country: string; region: string; city: string; address: string }

const getAddressFieldsFromAddressInputData = (
  аddressСomponents: IExternalDetailsResponse['аddressСomponents']
): TAddressFields => {
  const filteredComponents: Partial<Record<TToponymKind, string>> = Object.fromEntries(
    аddressСomponents.map((item) => [item.kind, item.name])
  )
  return {
    country: filteredComponents.country,
    region: filteredComponents.area,
    city: filteredComponents.locality,
    address: [filteredComponents.street, filteredComponents.house].filter(Boolean).join(', '),
  }
}

const geoSuggestUtils = {
  getAddressFieldsFromAddressInputData,
}

export default geoSuggestUtils
